<template>
  <div>
    <base-header class="pb-6" type="indigo">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">Create Company</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-row>
        <b-col cols="12" xl="10" offset-xl="1">
          <b-card>
            <validation-observer v-slot="{ valid, handleSubmit }">
              <b-form role="form" @submit.prevent="handleSubmit(createCompany)">
                <b-card-body>
                  <!-- Basic fields -->
                  <b-row class="border-bottom pb-3">
                    <b-col cols="12" sm="4">
                      <h4 class="display-4 uppercase">Registration</h4>
                      <p class="text-muted">
                        Only Isle of Man 1931 Act Companies are currently
                        supported.
                      </p>
                    </b-col>
                    <b-col cols="12" sm="7" offset-sm="1">
                      <b-row>
                        <b-col cols="12" md="6">
                          <base-input label="Jurisdiction" name="Jurisdiction">
                            <select class="form-control" v-model="jurisdiction">
                              <option value="isle_of_man">Isle of Man</option>
                            </select>
                          </base-input>
                        </b-col>

                        <b-col cols="12" md="6">
                          <base-input label="Entity Type" name="Entity Type">
                            <select class="form-control" v-model="type">
                              <option
                                value="iom_1931_act_company_limited_by_shares"
                              >
                                1931 Act Company (Limited By Shares)
                              </option>
                            </select>
                          </base-input>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col cols="12" md="6">
                          <base-input
                            label="Company Name"
                            name="Name"
                            :rules="{ required: true }"
                            :debounce="500"
                            placeholder="e.g. Company Name Limited"
                            v-model="name"
                          ></base-input>
                        </b-col>
                        <b-col cols="12" md="6">
                          <base-input
                            label="Company Number"
                            name="Number"
                            :rules="{ required: true }"
                            :debounce="500"
                            placeholder="e.g. 80619C"
                            v-model="number"
                          ></base-input>
                        </b-col>
                      </b-row>

                      <!-- address -->
                      <base-input
                        label="Registered Address"
                        name="Address"
                        :rules="{ required: true }"
                      >
                        <!-- TODO: make field required in validation rules -->
                        <address-autocomplete-input
                          v-model="address"
                          placeholder="e.g. 12 Marine Drive, Douglas, IM8 XE1"
                        >
                        </address-autocomplete-input>
                      </base-input>

                      <b-row>
                        <!-- incorp date -->
                        <b-col cols="12" md="6">
                          <base-input
                            label="Incorporation Date"
                            name="Incorporation Date"
                            type="date"
                            v-model="incorporationDate"
                          ></base-input>
                        </b-col>
                        <!-- status -->
                        <b-col cols="12" md="6">
                          <base-input label="Status" name="Status">
                            <select class="form-control" v-model="status">
                              <option value="active">Active</option>
                              <option value="dissolved">Dissolved</option>
                            </select>
                          </base-input>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row class="border-bottom py-3">
                    <b-col cols="12" sm="4">
                      <h4 class="display-4 uppercase">Business Information</h4>
                      <p class="text-muted">
                        Please provide some more information about the company
                      </p>
                    </b-col>
                    <b-col cols="12" sm="7" offset-sm="1">
                      <b-row>
                        <b-col>
                          <base-input
                            label="Main Business Activity"
                            name="Activity"
                            :rules="{ required: true }"
                            :debounce="500"
                            placeholder="e.g. Wholesale Beverage Distribution"
                            v-model="businessActivity"
                          ></base-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <!-- incorp date -->
                        <b-col cols="12" md="6">
                          <base-input
                            label="Reporting Currency"
                            name="Currency"
                          >
                            <select class="form-control" v-model="currency">
                              <option
                                v-for="currency in currencies"
                                :key="currency.code"
                                :value="currency.code"
                              >
                                {{ currency.currency }} ({{ currency.code }})
                              </option>
                              <option value="active">Active</option>
                              <option value="dissolved">Dissolved</option>
                            </select>
                          </base-input>
                        </b-col>
                        <!-- status -->
                        <b-col cols="12" md="6">
                          <b-row>
                            <b-col cols="7">
                              <base-input
                                label="Year end (month)"
                                name="Year end month"
                              >
                                <select
                                  class="form-control"
                                  v-model="yearEndMonth"
                                >
                                  <option value="01">January</option>
                                  <option value="02">February</option>
                                  <option value="03">March</option>
                                  <option value="04">April</option>
                                  <option value="05">May</option>
                                  <option value="06">June</option>
                                  <option value="07">July</option>
                                  <option value="08">August</option>
                                  <option value="09">September</option>
                                  <option value="10">October</option>
                                  <option value="11">November</option>
                                  <option value="12">December</option>
                                </select>
                              </base-input>
                            </b-col>
                            <b-col cols="5">
                              <base-input label="(day)" name="Year end day">
                                <select
                                  class="form-control"
                                  v-model="yearEndDay"
                                >
                                  <option
                                    v-for="date in yearEndDays"
                                    :key="date.value"
                                    :value="date.value"
                                    :disabled="date.disabled"
                                  >
                                    {{ date.label }}
                                  </option>
                                </select>
                              </base-input>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row
                    class="pt-3"
                    v-if="type === 'iom_1931_act_company_limited_by_shares'"
                  >
                    <b-col cols="12" sm="4">
                      <h4 class="display-4 uppercase">Reporting details</h4>
                      <p class="text-muted">
                        These details are used to prepare the company's Annual
                        Return form.
                      </p>
                    </b-col>
                    <b-col cols="12" sm="7" offset-sm="1">
                      <small class="form-text text-muted mb-2">
                        As defined by the
                        <a
                          href="https://www.tynwald.org.im/business/opqp/sittings/20112014/2013-SD-0242.pdf"
                          target="_blank"
                          >Companies (Fees and Duties) Order 2013 (SD242/13)</a
                        >:
                      </small>
                      <!-- Is charity? -->
                      <b-row class="mb-2">
                        <b-col cols="10">
                          <label class="form-control-label align-bottom"
                            >Is the company a charity?</label
                          >
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="isCharity"
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- Is excepted company? -->
                      <b-row class="mb-2">
                        <b-col cols="10">
                          <label class="form-control-label align-bottom"
                            >Is the company an excepted company?</label
                          >
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="isExceptedCompany"
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <hr />

                      <!-- Timeshare -->
                      <small class="form-text text-muted mb-2">
                        As defined in Section 20 of the
                        <a
                          href="https://legislation.gov.im/cms/images/LEGISLATION/PRINCIPAL/1996/1996-0007/TimeshareAct1996_3.pdf"
                          target="_blank"
                          >Timeshare Act 1996</a
                        >:
                      </small>
                      <!-- Is Timeshare Stakeholder? -->
                      <b-row class="mb-2">
                        <b-col cols="10">
                          <label class="form-control-label align-bottom"
                            >Is the company a timeshare stakeholder?</label
                          >
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="isTimeshareStakeholder"
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- Has issued paid up shares? -->
                      <b-row v-if="isTimeshareStakeholder" class="mb-2">
                        <b-col cols="10">
                          <label class="form-control-label align-bottom">
                            Has the company issued shares fully paid up in cash
                            of the minimum nominal value required by section
                            109(3B)(a) of the
                            <a
                              href="https://legislation.gov.im/cms/images/LEGISLATION/PRINCIPAL/1931/1931-0002/CompaniesAct1931_10.pdf"
                              target="_blank"
                              >Companies Act 1931</a
                            >?
                          </label>
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="hasIssuedPaidUpShares"
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- has indemnity insurance -->
                      <b-row v-if="isTimeshareStakeholder" class="mb-2">
                        <b-col cols="10">
                          <label class="form-control-label align-bottom">
                            Does the company hold indemnity insurance, for such
                            sum and in respect of such liabilities as are
                            specified in section 109 (3B)(b) of the
                            <a
                              href="https://legislation.gov.im/cms/images/LEGISLATION/PRINCIPAL/1931/1931-0002/CompaniesAct1931_10.pdf"
                              target="_blank"
                              >Companies Act 1931</a
                            >?
                          </label>
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="hasIndemnityInsurance"
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <hr />

                      <small class="form-text text-muted mb-2">
                        With regards to the
                        <a
                          href="https://legislation.gov.im/cms/images/LEGISLATION/PRINCIPAL/2017/2017-0003/BeneficialOwnershipAct2017_4.pdf"
                          target="_blank"
                          >Beneficial Ownership Act 2017</a
                        >:
                      </small>
                      <!-- Beneficial Ownership Act Is Applicable? -->
                      <b-row class="mb-2">
                        <b-col cols="10">
                          <label class="form-control-label align-bottom">
                            Does the Beneficial Ownership Act apply to the
                            company?
                          </label>
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="beneficialOwnershipActIsApplicable"
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- Is listed entity? -->
                      <b-row
                        class="mb-2"
                        v-if="!beneficialOwnershipActIsApplicable"
                      >
                        <b-col cols="10">
                          <label class="form-control-label align-bottom">
                            Is the company listed on a stock or investment
                            exchange recognised by the Treasury?
                          </label>
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="isListedEntity"
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- Is listed entity subsidiary? -->
                      <b-row
                        class="mb-2"
                        v-if="!beneficialOwnershipActIsApplicable"
                      >
                        <b-col cols="10">
                          <label class="form-control-label align-bottom">
                            Is the company a wholly owned subsidiary of a legal
                            entity listed on a stock or investment exchange
                            recognised by Treasury, where the disclosure
                            obligations on the legal entity include beneficial
                            ownership information in respect of the entity and
                            its subsidiaries?
                          </label>
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="isListedEntitySubsidiary"
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- treasury Order Applies -->
                      <b-row
                        class="mb-2"
                        v-if="!beneficialOwnershipActIsApplicable"
                      >
                        <b-col cols="10">
                          <label class="form-control-label align-bottom">
                            Does an Order made by the Treasury under section
                            5(4) of the Beneficial Ownership Act 2017 apply to
                            the company?
                          </label>
                        </b-col>
                        <b-col cols="2">
                          <base-switch
                            class="mr-1"
                            v-model="treasuryOrderApplies"
                          ></base-switch>
                        </b-col>
                      </b-row>

                      <!-- treasury order details -->
                      <b-row
                        class="mb-2"
                        v-if="
                          !beneficialOwnershipActIsApplicable &&
                          treasuryOrderApplies
                        "
                      >
                        <b-col>
                          <base-input
                            label="Which Treasury Order applies to the company?"
                            name="Treasury Order"
                            :rules="{
                              required:
                                !beneficialOwnershipActIsApplicable &&
                                treasuryOrderApplies,
                            }"
                            :debounce="500"
                            placeholder="Treasury Order details"
                            v-model="treasuryOrderDetails"
                          ></base-input>
                        </b-col>
                      </b-row>

                      <hr />

                      <small class="form-text text-muted mb-2">
                        In respect of all mortgages and charges of the kind
                        which are required to be registered with the Department
                        of Economic Development:
                      </small>

                      <b-row>
                        <b-col cols="6">
                          <label class="form-control-label align-bottom">
                            What is the total amount of indebtedness of the
                            company?
                          </label>
                        </b-col>

                        <b-col>
                          <currency-input
                            class="form-control"
                            v-model="indebtedness"
                            :currency="currency"
                            :value-as-integer="true"
                          />
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-card-body>
                <b-card-footer>
                  <b-row>
                    <b-col>
                      <b-btn @click="$router.go(-1)">
                        <i class="fa fa-times mr-2"></i> Cancel
                      </b-btn>
                    </b-col>
                    <b-col class="text-right">
                      <span v-if="!valid" class="text-danger mr-4"
                        >Please complete all required fields.</span
                      >
                      <base-button native-type="submit" :disabled="!valid">
                        <span v-if="!saving">
                          Save company
                          <i class="fa fa-arrow-right ml-2"></i>
                        </span>
                        <span v-else>
                          <i class="fa fa-spin fa-spinner mr-2"></i> Please
                          wait&hellip;
                        </span>
                      </base-button>
                    </b-col>
                  </b-row>
                </b-card-footer>
              </b-form>
            </validation-observer>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <b-modal
      id="select-company-modal"
      size="sm"
      ok-title="Continue"
      cancel-title="Skip"
    >
      <h6 slot="modal-header" class="modal-title">Select your company</h6>

      <p>Fetch public information from the registry.</p>

      <base-input label="Company name or number">
        <el-select
          ref="companySearch"
          v-model="companySearchResult"
          filterable
          placeholder="Example Company Limited"
          remote
          :remote-method="searchCompanies"
          :loading="searchingCompanies"
          default-first-option
          @change="onCompanySelection"
        >
          <el-option
            v-for="result in companySearchResults"
            :key="result.id"
            :label="$options.filters.decode(result.name)"
            :value="result"
          ></el-option>
        </el-select>
      </base-input>
    </b-modal>
  </div>
</template>
<script>
import currencies from "currency-codes";
import _ from "underscore";
import moment from "moment";
import { get } from "dot-prop";

import { Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";
import AddressAutocompleteInput from "../../Forms/AddressAutocompleteInput";

export default {
  name: "company-create",
  components: {
    StatsCard,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    AddressAutocompleteInput,
  },
  data() {
    return {
      currencies: currencies.data,
      jurisdiction: "isle_of_man",
      type: "iom_1931_act_company_limited_by_shares",
      name: "",
      number: "",
      address: "",
      status: "active",
      incorporationDate: moment().subtract(1, "year").format("YYYY-MM-DD"),
      businessActivity: "",
      currency: "GBP",
      yearEndMonth: "01",
      yearEndDay: "01",
      indebtedness: 0,
      isCharity: false,
      isExceptedCompany: false,
      isTimeshareStakeholder: false,
      hasIndemnityInsurance: false,
      hasIssuedPaidUpShares: false,
      beneficialOwnershipActIsApplicable: true,
      isListedEntity: false,
      isListedEntitySubsidiary: false,
      treasuryOrderApplies: false,
      treasuryOrderDetails: "",
      errorMessage: null,
      errors: {},
      saving: false,
      // company search
      companySearchResult: null,
      searchingCompanies: false,
      companySearchResults: [],
    };
  },
  computed: {
    account: function () {
      return this.$store.state.account;
    },
    yearEndDays: function () {
      const days = [];
      _.times(31, (n) => {
        let d = n + 1;
        if (this.yearEndMonth === "02") {
          // 28 days in Feb
          if (d > 28) {
            return;
          }
        } else if (_.contains(["04", "06", "09", "11"], this.yearEndMonth)) {
          if (d > 30) {
            return;
          }
        }

        const twoDigitDate = d.toString().padStart(2, "0");
        return days.push({
          value: twoDigitDate,
          label: moment(twoDigitDate, "DD").format("Do"),
          disabled: false,
        });
      });

      return days;
    },
  },
  watch: {
    incorporationDate: function (newVal, oldVal) {
      // parse the date and set to fields - year end date should be one day before the incorp date
      const date = moment(newVal, "YYYY-MM-DD").subtract(1, "day");
      this.yearEndMonth = date.format("MM");
      this.yearEndDay = date.format("DD");
    },
    // TODO: watch country change and set currency code e.g. cc.country('colombia')
  },
  mounted() {
    // open the select company modal
    this.$bvModal.show("select-company-modal");

    setTimeout(() => {
      this.$nextTick(() => {
        // focus on input
        this.$refs.companySearch.focus();
      });
    }, 1000);
  },
  methods: {
    createCompany: function () {
      const requestBody = {};
      // build up the request body
      requestBody.name = this.name;
      requestBody.number = this.number;
      requestBody.address = this.address;
      requestBody.jurisdiction = this.jurisdiction;
      requestBody.type = this.type;
      requestBody.status = this.status;
      requestBody.incorporationDate = this.incorporationDate;
      requestBody.businessActivity = this.businessActivity;
      requestBody.currency = this.currency;

      if (this.yearEndMonth && this.yearEndDay) {
        requestBody.yearEndDate = `${this.yearEndMonth}-${this.yearEndDay}`;
      }

      if (this.type === "iom_1931_act_company_limited_by_shares") {
        requestBody.details = {};
        requestBody.details.isExceptedCompany = this.isExceptedCompany;
        requestBody.details.isCharity = this.isCharity;
        requestBody.details.indebtedness = this.indebtedness;

        // beneficial ownership act
        requestBody.details.beneficialOwnershipAct = {};
        requestBody.details.beneficialOwnershipAct.isApplicable = this.beneficialOwnershipActIsApplicable;
        if (!this.beneficialOwnershipActIsApplicable) {
          requestBody.details.beneficialOwnershipAct.isListedEntity = this.isListedEntity;
          requestBody.details.beneficialOwnershipAct.isListedEntitySubsidiary = this.isListedEntitySubsidiary;
          requestBody.details.beneficialOwnershipAct.treasuryOrderApplies = this.treasuryOrderApplies;
          if (this.treasuryOrderApplies) {
            requestBody.details.beneficialOwnershipAct.treasuryOrderDetails = this.treasuryOrderDetails;
          }
        }

        // timeshare stakeholder
        requestBody.details.timeshareStakeholder = {};
        requestBody.details.timeshareStakeholder.isTimeshareStakeholder = this.isTimeshareStakeholder;
        if (this.isTimeshareStakeholder) {
          requestBody.details.timeshareStakeholder.hasIndemnityInsurance = this.hasIndemnityInsurance;
          requestBody.details.timeshareStakeholder.hasIssuedPaidUpShares = this.hasIssuedPaidUpShares;
        }
      }

      // send the request
      this.saving = true;
      this.axios
        .post(`/v1/accounts/${this.account.id}/companies`, requestBody)
        .then((response) => {
          this.saving = false;
          // notify
          this.$notify({
            message: "Company created",
            timeout: 3000,
            icon: "fa fa-check",
            type: "success",
          });

          this.$router.push(`/companies/${response.data.id}`);
        })
        .catch((error) => {
          this.saving = false;
          this.errorMessage = "Failed to create company";
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    },
    searchCompanies(query) {
      if (query === "") {
        this.companySearchResults = [];
        return null;
      }

      this.searchingCompanies = true;
      this.axios
        .get(`https://info-api.adminhero.co/v1/companies?q=${query}`)
        .then((response) => {
          this.searchingCompanies = false;
          this.companySearchResults = response.data;
        })
        .catch((error) => {
          this.searchingCompanies = false;
          console.error("Error seraching companies: ", error);
        });
    },
    onCompanySelection(val) {
      // set to company
      if (val.name) {
        this.name = val.name; // could humanize this (by default name is all uppercase)
      }

      if (val.number) {
        this.number = val.number;
      }

      if (val.status === "Live") {
        this.status = "active";
      } else {
        this.status = "dissolved";
      }

      if (val.address) {
        this.address = val.address;
      }

      if (val.incorporationDate) {
        this.incorporationDate = val.incorporationDate;
      }

      // hide the modal
      this.$bvModal.hide("select-company-modal");
    },
  },
};
</script>
<style>
.starter-page {
  min-height: calc(100vh - 380px);
}
</style>
